/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-button-list[_ngcontent-%COMP%]   .happ-button-list[_ngcontent-%COMP%]{background:#fff;margin:5px;font-size:14px;padding:5px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:inline-block}app-button-list[_ngcontent-%COMP%]   .happ-small-button[_ngcontent-%COMP%]{line-height:25px!important}app-button-list[_ngcontent-%COMP%]   .happ-list[_ngcontent-%COMP%]{flex-wrap:wrap}.sml-icon[_ngcontent-%COMP%]{font-size:17px;height:42px!important;margin:auto}.sml-icn-btn[_ngcontent-%COMP%]{height:25px!important}"];
export { styles as styles };
